import React from "react";

import { useMetrics } from "../Engine/src/Controls/Internals/Metrics/MetricsProviderContext";

import { useAsyncEffect } from "./UseAsyncEffect";
import { useNidusClient } from "./NidusClient/NidusClientContext";
import { NidusEntryData } from "./NidusClient/INidusClient";

export interface UseShowOnceProps {
    nidusName: string;
    nidusKey: string;
    infoName: string;
    onCloseMetricName: string;
    openFromMetricName: string;
    openFromLink?: boolean;
}

export interface UseShowOnceResponse {
    isOpen: boolean;
    setIsOpen: (flag: boolean) => void;
    addToNidus: () => Promise<void>;
}

export interface Info extends NidusEntryData {
    name: string;
    date: string;
}

export const useShowOnce = (props: UseShowOnceProps): UseShowOnceResponse => {
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [isSaveInNidus, setIsSaveInNidus] = React.useState<boolean>(false);
    const nidus = useNidusClient();
    const track = useMetrics();
    const nidusName = props.nidusName;
    const nidusKey = props.nidusKey;
    const info: Info = {
        name: props.infoName,
        date: new Date().toUTCString(),
    };

    async function addToNidus() {
        track(props.onCloseMetricName, {
            from: props.openFromMetricName,
        });

        if (isSaveInNidus) {
            await nidus.insert(nidusName, nidusKey, info);
            setIsSaveInNidus(false);
        }
    }

    async function searchInNidus(id: string) {
        const result = await nidus.searchMinitour(nidusName, nidusKey, id);
        if (result.totalSuitableCount === 0) {
            setIsSaveInNidus(true);
        }
        return result;
    }

    useAsyncEffect(async () => {
        await searchInNidus(info.name).then(result => {
            const itemsCount = result.items.length;
            if (itemsCount === 0) {
                setIsOpen(true);
            }
        });
    }, []);

    useAsyncEffect(async () => {
        if (props.openFromLink) {
            setIsOpen(false);
            await addToNidus();
        }
    }, [props.openFromLink]);

    return { isOpen: isOpen, setIsOpen: setIsOpen, addToNidus: addToNidus };
};
